import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { MotesPaths } from '../models/motes-paths';
import { FeaturedTour } from '../models/featuredTour';
import { DatabaseService } from './database.service';

@Injectable({ providedIn: 'root' })

export class FeaturedTourService {

    constructor(private db: DatabaseService) { }

    public init() { }


    public updateFeaturedTour(featuredTour: FeaturedTour): Promise<any> {
        return this.db.database.ref("featuredTours/" + featuredTour.key).update(featuredTour.toJson());
    }

    /**
     * Watch all published featured tours
     */
    public watchPublishedFeatures() {
        // Get all published featured tours
        let query = (ref) => ref.orderByChild('published').equalTo(true);

        return this.db.database.list(MotesPaths.FEATURED_DB_PATH(), query).snapshotChanges().pipe(map(snapList => {
            if(snapList.length <= 0) return null;
            // Get payload json from firebase and create FeaturedTour objects
            return snapList.map((snap) => new FeaturedTour(snap.key, snap.payload.val()));
        }));
    }

    /**
     * Watch featured tour by its key
     */
    public watchFeaturedTour(key: string): Observable<FeaturedTour> {
        return this.db.object(MotesPaths.FEATURED_DB_PATH(key)).snapshotChanges().pipe(map(snap => {
            return new FeaturedTour(snap.key, snap.payload.val());
        }));
    }

    /**
     * Get featured tour by its key
     */
    public getFeaturedTour(key: string): Promise<FeaturedTour> {
        return this.watchFeaturedTour(key).pipe(first()).toPromise();
    }

    /**
     * Watch featured tour by its tour key reference
     */
    public watchTourFeature(tourKey: string): Observable<FeaturedTour> {
        // Get all featured tours belonging to this tour
        let query = (ref) => ref.orderByChild('tourKey').equalTo(tourKey);

        return this.db.database.list(MotesPaths.FEATURED_DB_PATH(), query).snapshotChanges().pipe(map(snapList => {
            if(snapList.length <= 0) return null;
            // Get payload json from firebase and create FeaturedTour object
            return new FeaturedTour(snapList[0].key, snapList[0].payload.val());
        }));
    }

    /**
     * Get featured tour by its tour key reference
     */
    public getTourFeature(tourKey: string): Promise<FeaturedTour> {
        return this.watchTourFeature(tourKey).pipe(first()).toPromise();
    }
}
